module.exports = __webpack_public_path__ + "img/539-42dfb3.png";